import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from 'components/cards/new/common/RightRobotCard'

const features = [
  {
    description:
      'Embed business address functionality into your product with our encrypted API. Integration is supported with documentation, sandbox testing, and example code in multiple languages.',
    title: 'Secure REST API',
  },
  {
    description:
      'No dev team? No problem. Our branded portal lets you offer address services, manage subscriptions, and track customer activity—without any backend setup.',
    title: 'White-Label Partner Portal',
  },
  {
    description: `Use the API, Partner Portal, or both. Whether you're launching with 10 customers or 10,000, our platform grows with you.`,
    title: 'Custom Integration Styles',
  },
]

const EnterpriseGradeDevTool = () => {
  const size = useWindowSize()
  return (
    <RightRobotCard
      image={{
        alt: 'Robot holding phone for enterprise development',
        desktop: {
          dimensions: {
            height: 820,
            width: 678,
          },
          src: '/images/new/au/robot-holding-phone.png',
        },
        mobile: {
          dimensions: {
            height: 436,
            width: 360,
          },
          src: '/images/new/au/robot-holding-phone.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '45%' : '100%'}
      imageStyle={{
        maxHeight: '100%',
        objectFit: 'contain',
        width: '100%',
      }}
      overrideAllImageStyles
      reverseColumnOrder
    >
      <div className='d-flex flex-column flex-1 px-4 pb-14 ps-lg-20 py-lg-17 gap-6'>
        <h2 className='fs-fluid-36-80 lh-105 fw-semibold mb-0'>
          Enterprise-Grade Developer Tools
        </h2>
        <div className='d-flex flex-column gap-7'>
          {features.map((feature) => (
            <div key={feature.title}>
              <h3 className='fs-fluid-20-32 lh-114'>{feature.title}</h3>
              <div className='fs-fluid-16-20 lh-134 lh-lg-114 color-grey5'>
                {feature.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </RightRobotCard>
  )
}

export default EnterpriseGradeDevTool
